import { withInstall } from '@lit-element/utils'
import Statistic from './src/statistic.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtStatistic: SFCWithInstall<typeof Statistic> =
  withInstall(Statistic)

export default LtStatistic
export * from './src/statistic'
